"use strict";

var _interopRequireDefault = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _objectSpread2 = _interopRequireDefault(require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _waves = _interopRequireDefault(require("@/directive/waves"));
var _vuex = require("vuex");
var _common = require("@/api/common");
var _imageToVideo = _interopRequireDefault(require("@/components/imageToVideo.vue"));
var _default = exports.default = {
  components: {
    imageToVideo: _imageToVideo.default,
    Pagination: _Pagination.default
  },
  directives: {
    waves: _waves.default
  },
  data: function data() {
    return {
      playbackRate: 4.0,
      listLoading: false,
      times: [],
      list: [],
      total: 0,
      listQuery: {
        page: 1,
        size: 20,
        anchor_id: '',
        user_id: '',
        call_record_id: '',
        startTime: '',
        endTime: ''
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['roles'])),
  watch: {
    times: function times(val) {
      this.listQuery.startTime = '';
      this.listQuery.endTime = '';
      if (val) {
        this.listQuery.startTime = val[0];
        this.listQuery.endTime = val[1];
      }
    }
  },
  mounted: function mounted() {},
  created: function created() {
    this.getList();
  },
  methods: {
    getList: function () {
      var _getList = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
        var _yield$reviewVideoLis, code, data;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              this.listLoading = true;
              _context.n = 1;
              return (0, _common.reviewVideoList)(this.listQuery);
            case 1:
              _yield$reviewVideoLis = _context.v;
              code = _yield$reviewVideoLis.code;
              data = _yield$reviewVideoLis.data;
              this.listLoading = false;
              if (code === 0) {
                this.list = data.list;
                this.total = data.total;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getList() {
        return _getList.apply(this, arguments);
      }
      return getList;
    }(),
    setPlaybackRate: function setPlaybackRate() {
      var _this = this;
      this.$prompt('请输入全局倍率 0 - 10', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^(?:[1-9](?:\.\d+)?|0(?:\.\d+)?|10)$/i,
        inputErrorMessage: '必须输入 0-10 之间的数字'
      }).then(function (_ref) {
        var value = _ref.value;
        _this.playbackRate = parseFloat(value);
      }).catch(function () {});
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    }
  }
};